import { SearchInput } from '../shared';
import { SortOrder, BusinessRoleSortType } from '../enums';

export class GetBusinessRolesInput extends SearchInput<BusinessRoleSortType> {
    constructor() {
        super(BusinessRoleSortType.Name);
        this.sortOrder = SortOrder.Ascending;
    }
}
